var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],style:({left: (_vm.x + "px"), top: (_vm.y + "px")}),attrs:{"id":"context-menu"}},_vm._l((_vm.menu),function(item){return _c('li',{key:item.txt,on:{"click":function($event){_vm.clickItem($event, item)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26550cc0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ContextMenu.vue
// module id = null
// module chunks = 